import React from "react";

function toLocalISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function localDateKey(input: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(input)) return input;
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return input;
  return toLocalISODate(d);
}

export default function StreakDisplay({
  history,
}: {
  history: Array<{ date: string }>;
}) {
  const today = new Date();
  const days = new Set(history.map((h) => localDateKey(h.date)));
  let streak = 0;
  for (let i = 0; i < 365; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    const key = toLocalISODate(d);
    if (days.has(key)) streak++;
    else break;
  }
  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <strong>Streak</strong>
      </div>
      <div style={styles.streakValue}>{streak} days</div>
    </div>
  );
}

const styles: { [k: string]: React.CSSProperties } = {
  card: { backgroundColor: "#2a2a2a", borderRadius: 8, padding: 12 },
  cardHeader: { fontWeight: 700, marginBottom: 6 },
  streakValue: { fontSize: 28, fontWeight: 700, textAlign: "center" },
};
